import { APP_ACTIONS } from '../actions/app';

const initialState = {
  isSidebarOpen: true, // Default state when app loads
  permissionDeniedModal: {
    visible: false
  }
};

const appReducer = (state = initialState, action) => {
  switch (action.type) {
    case APP_ACTIONS.TOGGLE_SIDEBAR:
      return {
        ...state,
        isSidebarOpen: !state.isSidebarOpen
      };
    case APP_ACTIONS.SET_SIDEBAR_STATE:
      return {
        ...state,
        isSidebarOpen: action.payload
      };
    case APP_ACTIONS.SHOW_PERMISSION_DENIED:
      return {
        ...state,
        permissionDeniedModal: {
          visible: true
        }
      };
    case APP_ACTIONS.HIDE_PERMISSION_DENIED:
      return {
        ...state,
        permissionDeniedModal: {
          visible: false
        }
      };
    default:
      return state;
  }
};

export default appReducer;
